import { Badge, Box, Container, Stack, Text, Title, useMantineTheme } from '@mantine/core';

import { motion, useReducedMotion } from 'framer-motion';

import { PRIMARY_FONT } from '../../constants/fonts';

const HeroSection = () => {
  const theme = useMantineTheme();
  const shouldReduceMotion = useReducedMotion();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  };

  return (
    <section
      id="home"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background Image */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("/hero.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          transform: 'scale(1.05)',
          zIndex: 0,
        }}
      />

      {/* Subtle overlay for text readability */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.3)',
          zIndex: 1,
        }}
      />

      <Container size="lg" style={{ position: 'relative', zIndex: 2, width: '100%' }}>
        <motion.div
          variants={shouldReduceMotion ? {} : containerVariants}
          initial="hidden"
          animate="visible"
          style={{ textAlign: 'center' }}
        >
          <Stack gap="lg" align="center">
            <motion.div variants={shouldReduceMotion ? {} : itemVariants}>
              <Text
                size="md"
                style={{
                  fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                  fontFamily: PRIMARY_FONT,
                  fontWeight: 400,
                  color: 'white',
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  marginBottom: '1rem',
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                }}
              >
                Bierzemy ślub!
              </Text>
            </motion.div>

            <motion.div variants={shouldReduceMotion ? {} : itemVariants}>
              <Title
                order={1}
                style={{
                  fontSize: 'clamp(4rem, 12vw, 8rem)',
                  fontFamily: PRIMARY_FONT,
                  fontWeight: 100,
                  color: "white",
                  textAlign: 'center',
                  lineHeight: 1.1,
                  marginBottom: '2rem',
                  textShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
                  letterSpacing: '-0.02em',
                }}
              >
                Ula & Dawid
              </Title>
            </motion.div>

            <motion.div variants={shouldReduceMotion ? {} : itemVariants}>
              <Text
                size="lg"
                style={{
                  fontSize: 'clamp(1.2rem, 3vw, 1.8rem)',
                  fontFamily: PRIMARY_FONT,
                  fontWeight: 300,
                  color: 'white',
                  letterSpacing: '0.05em',
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                }}
              >
                19 lipca 2025
              </Text>
            </motion.div>
          </Stack>
        </motion.div>
      </Container>
    </section>
  );
};

export { HeroSection };
export default HeroSection;
